import { Toolbar } from '@components/Toolbar/export'
import { Topbar } from '@components/Topbar/export'
import { TexturesPanel } from '@components/Viewer3D/TexturesPanel'
import { DimensionsHeader } from '@components/Viewer3D/DimensionsHeader'

/**
 * Chrome de escritorio — equivalente 1:1 al layout histórico del planner.
 * No contiene el Canvas; vive como overlay sobre CanvasHost.
 *
 * Correspondencia: ATEMPORAL mobile-28-07-2026 (`47ee2081`).
 */
export function DesktopChrome() {
  return (
    <>
      <Topbar />
      <Toolbar />
      <TexturesPanel />
      <DimensionsHeader />
    </>
  )
}
